<template>
  <section class="content">
    <div class="container-fluid">  
            <div class="card">
            <div class="overlay" id="cardloader"><div class="load-bar"><div class="bar"></div><div class="bar"></div><div class="bar"></div></div></div>
              <div class="card-header">
                <h3 class="card-title">List Data {{title}}</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Add New
                  </button>
                  <vue-excel-xlsx
                      :data="exportdata"
                      :columns="exportcolumn"
                      :file-name="'Export-Master-Data-PesertaKelas'"
                      :file-type="'xlsx'"
                      :sheet-name="'Sheet1'"
                      class="btn btn-sm btn-warning"
                      >
                      <i class="fa fa-file-excel"></i> Download
                  </vue-excel-xlsx>
                </div>
              </div>
              <!-- /.card-header -->
              <!-- <div class="card-body table-responsive p-0"> -->
              <div class="card-body">
                <data-table :columns="columns" class="display table table-bordered table-hover" :ajax="ajax" ></data-table>
              </div>
              <!-- /.card-body -->
            </div>
      </div>
            <!-- /.card -->
            <!-- Modal -->
        <div class="modal hide modal-full fade" id="addNew" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
            <div class="modal-dialog modal-dialog-full " role="document">
                <div class="modal-content modal-content-full">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode && !pesertamode && !aktivitasmode && !makminmode">Create New {{title}}</h5>
                    <h5 class="modal-title" v-show="(editmode && !pesertamode && !aktivitasmode && !makminmode)">Edit {{title}}</h5>
                    <h5 class="modal-title" v-show="(!editmode && pesertamode && !aktivitasmode && !makminmode)">Manajemen {{title}}</h5>
                    <h5 class="modal-title" v-show="(!editmode && !pesertamode && aktivitasmode && !makminmode)">Aktivitas {{title}}</h5>
                    <h5 class="modal-title" v-show="(!editmode && !pesertamode && !aktivitasmode && makminmode)">Makan & Minum {{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="(editmode ? updateData() : (pesertamode ? pesertaData() : (aktivitasmode ? aktivitasData() : (makminmode ? makminData() : createData()))))" class="form-horizontal">
                    <div class="modal-body" v-show="(editmode && !pesertamode && !aktivitasmode && !makminmode) || (!editmode && !pesertamode && !aktivitasmode && !makminmode)">
                        <div class="form-group row" v-show="isKelasValid">
                            <label class="col-md-2">Nama Program</label>
                            <div class="col-md-10">
                              <Select2 v-model="form.id_kelas" :options="listkelas" @change="myChangeEvent($event)" @select="mySelectEvent($event)" placeholder="Nama Program"/>
                              <has-error :form="form" field="id_kelas"></has-error>
                            </div>
                        </div>
                        <div v-show="(editmode && !pesertamode && !aktivitasmode && !makminmode) || (!editmode && !pesertamode && !aktivitasmode && !makminmode)" class="form-group row">
                            <label class="col-md-2">Nama Kelas</label>
                            <div class="col-md-10">
                              <input v-model="form.nama" type="text" name="nama"
                                  class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                              <has-error :form="form" field="nama"></has-error>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-2">Keterangan</label>
                            <div class="col-md-10">
                              <input v-model="form.keterangan" type="text" name="keterangan"
                                  class="form-control" :class="{ 'is-invalid': form.errors.has('keterangan') }">
                              <has-error :form="form" field="keterangan"></has-error>
                            </div>
                        </div>
                        <!-- <div class="form-group row">
                            <label class="col-md-2">Tgl. Awal Kelas</label>
                              <div class="col-md-10">
                              <date-picker v-model="form.tgl_awal" valueType="format" value-type="format"  input-class="form-control" style="width: 100%;"></date-picker>
                              </div>
                              <has-error :form="form" field="tgl_awal"></has-error>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-2">Tgl. Akhir Kelas</label>
                              <div class="col-md-10">
                              <date-picker v-model="form.tgl_akhir" valueType="format" input-class="form-control" style="width: 100%;"></date-picker>
                              </div>
                              <has-error :form="form" field="tgl_akhir"></has-error>
                        </div> -->
                        <div class="form-group row">
                            <label class="col-md-2">Status</label>
                            <div class="col-md-10">
                              <Select2 v-model="form.status_kelas" :options="liststatus" @change="myChangeEvent($event)" @select="mySelectEvent($event)" placeholder="Status Kelas"/>
                              <has-error :form="form" field="status_kelas"></has-error>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" v-show="(!editmode && pesertamode && !aktivitasmode && !makminmode)">
                      <div class="form-group row">
                          <label class="col-md-2">Nama Kelas</label>
                          <div class="col-md-10">
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }" readonly="readonly">
                            <has-error :form="form" field="nama"></has-error>
                          </div>
                      </div>
                      <hr/>
                      <div class="form-group row">
                        <!-- Toolbar: Search & Rows per page (Bootstrap 4) -->
                        <div class="d-flex align-items-center justify-content-between mb-2 w-100">
                          <!-- Input Group B4: pakai .input-group-prepend -->


                          <!-- B4 tidak punya .gap-2, dan .form-select → pakai .custom-select -->
                          <div class="d-flex align-items-center">
                            <!-- Status -->
                            <span class="text-muted small mr-2">Status</span>
                            <select
                              class="custom-select custom-select-sm mr-3"
                              v-model="statusFilter"
                              style="width:auto;"
                            >
                              <option value="all">Semua</option>
                              <option value="in">Di kelas</option>
                              <option value="out">Belum</option>
                            </select>

                            <!-- Rows -->
                            <span class="text-muted small mr-2">Rows</span>
                            <select
                              class="custom-select custom-select-sm"
                              v-model.number="pageSize"
                              style="width:auto;"
                            >
                              <option :value="5">5</option>
                              <option :value="10">10</option>
                              <option :value="20">20</option>
                              <option :value="50">50</option>
                            </select>
                          </div>
                          <div class="input-group" style="max-width:420px;">
                            <div class="input-group-prepend">
                              <span class="input-group-text"><span class="fa fa-search"></span></span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="q"
                              placeholder="Cari NIS / Nama / ID…"
                              autocomplete="off"
                              @keydown.enter.prevent
                            />
                          </div>
                        </div>

                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th width="5">#</th>
                              <th width="10">NIS</th>
                              <th width="25">Nama</th>
                              <th width="60">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="loading">
                              <td colspan="4">Loading…</td>
                            </tr>
                            <tr v-else-if="error">
                              <td colspan="4">Gagal memuat data</td>
                            </tr>
                            <tr v-if="!loading && !error" v-for="(s, i) in paginatedSiswa" :key="s.id">
                              <th scope="row">{{ pageStart + i + 1 }}</th>
                              <td>{{ s.nis }}
                                <span
                                  class="badge ml-2"
                                  :class="isInClass(s.id) ? 'badge-primary' : 'badge-secondary'"
                                >
                                  {{ isInClass(s.id) ? 'Di kelas' : 'Belum' }}
                                </span>
                              </td>
                              <td>{{ s.nama }}
                              </td>
                              <td>
                                <button
                                  type="button"
                                  class="btn btn-sm"
                                  :class="isInClass(s.id) ? 'btn-primary' : 'btn-secondary'"
                                  @click.stop="pilih(s)"
                                >
                                  Pilih
                                </button>
                              </td>
                            </tr>

                            <tr v-if="!loading && !error && paginatedSiswa.length === 0">
                              <td colspan="4">Tidak ada data</td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Footer: info & pager -->
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="small text-muted">
                            Menampilkan {{ Math.min(pageStart + 1, filteredCount) }}–{{ Math.min(pageStart + pageSize, filteredCount) }}
                            dari {{ filteredCount }} data
                          </div>

                          <ul class="pagination pagination-sm mb-0" role="navigation" aria-label="Pagination">
                            <li class="page-item" :class="{ disabled: page === 1 }">
                              <button type="button" class="page-link" @click="goto(1)" :disabled="page === 1">«</button>
                            </li>
                            <li class="page-item" :class="{ disabled: page === 1 }">
                              <button type="button" class="page-link" @click="prev" :disabled="page === 1">‹</button>
                            </li>

                            <li class="page-item disabled">
                              <span class="page-link">Page {{ page }} / {{ totalPages }}</span>
                            </li>

                            <li class="page-item" :class="{ disabled: page === totalPages }">
                              <button type="button" class="page-link" @click="next" :disabled="page === totalPages">›</button>
                            </li>
                            <li class="page-item" :class="{ disabled: page === totalPages }">
                              <button type="button" class="page-link" @click="goto(totalPages)" :disabled="page === totalPages">»</button>
                            </li>
                          </ul>
                        </div>
                      </div>

                    </div>
                    <div class="modal-body" v-show="(!editmode && !pesertamode && aktivitasmode && !makminmode)">
                      <div class="form-group row">
                          <label class="col-md-2">Nama Kelas</label>
                          <div class="col-md-10">
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }" readonly="readonly">
                            <has-error :form="form" field="nama"></has-error>
                          </div>
                      </div>
                      <div class="col-12 col-sm-12">
                          <small v-if="!canPickOutput" class="text-danger">Pilih Tanggal & Kegiatan dulu</small>
                      </div>
                      <div class="col-12 col-sm-12">
                        <div class="form-group row">
                            <!-- <label class="col-md-2">Tgl Kegiatan</label> -->
                            <div class="offset-md-8 col-md-4">
                              <date-picker v-model="form.tgl_kegiatan" valueType="format" input-class="form-control" style="width: 100%;" placeholder="Date..." @change="changedate($event)"></date-picker>
                            </div>
                        </div>
                      </div>
                      <div class="form-group col-md-12">
                          <label>Kegiatan </label>
                          <Select2Ajax name="id_kegiatan" v-model="form.id_kegiatan" v-if="!form.id_kegiatan" :ajaxurl="ajaxurl" @change="myChangeEvent($event)" @select="mySelectEvent($event)" /></Select2Ajax>
                          <Select2Ajax name="id_kegiatan" v-model="form.id_kegiatan" v-if="form.id_kegiatan" :options="listkegiatan" :ajaxurl="ajaxurl" @change="myChangeEvent($event)" @select="mySelectEvent($event)" /></Select2Ajax>
                          <has-error :form="form" field="id_kegiatan"></has-error>
                      </div>
                      <!-- TEMPLATE -->
                     <div class="form-group col-md-12">
                      <label>Daftar Kegiatan</label>

                      <div v-if="listkegiatankelas.length" class="list-group">
                        <div
                          v-for="item in listkegiatankelas"
                          :key="item.id"
                          class="list-group-item list-group-item-action d-flex align-items-start"
                          :class="{ active: selectedKegiatanId === item.id }"
                          tabindex="0"
                          @click="selectKegiatan(item)"
                          @keyup.enter="selectKegiatan(item)"
                        >
                          <!-- Teks -->
                          <div class="flex-grow-1">
                            {{ item.text }}
                          </div>

                          <!-- Tombol hapus (kanan), kliknya tidak memicu select -->
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger ms-2 btn-delete"
                            title="Hapus kegiatan"
                            aria-label="Hapus kegiatan"
                            @click.stop="hapusKegiatan(item)"
                          >
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>

                      <div v-else class="text-muted">
                        Belum ada kegiatan untuk tanggal & kelas ini.
                      </div>
                    </div>


                      <hr/>
                      <div class="form-group row">
                        <!-- Toolbar: Search & Rows per page (Bootstrap 4) -->
                        <div class="d-flex align-items-center justify-content-between mb-2 w-100">
                          <!-- Input Group B4: pakai .input-group-prepend -->


                          <!-- B4 tidak punya .gap-2, dan .form-select → pakai .custom-select -->
                          <div class="d-flex align-items-center">
                            <!-- Status -->
                            <span class="text-muted small mr-2">Status</span>
                            <select
                              class="custom-select custom-select-sm mr-3"
                              v-model="statusFilter"
                              style="width:auto;"
                            >
                              <!-- <option value="all">Semua</option> -->
                              <option value="in">Di kelas</option>
                              <!-- <option value="out">Belum</option> -->
                            </select>

                            <!-- Rows -->
                            <span class="text-muted small mr-2">Rows</span>
                            <select
                              class="custom-select custom-select-sm"
                              v-model.number="pageSize"
                              style="width:auto;"
                            >
                              <option :value="5">5</option>
                              <option :value="10">10</option>
                              <option :value="20">20</option>
                              <option :value="50">50</option>
                            </select>
                          </div>
                          <div class="input-group" style="max-width:320px;">
                            <div class="input-group-prepend">
                              <span class="input-group-text"><span class="fa fa-search"></span></span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="q"
                              placeholder="Cari NIS / Nama / ID…"
                              autocomplete="off"
                              @keydown.enter.prevent
                            />
                          </div>
                        </div>

                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th width="5">#</th>
                              <th width="10">NIS</th>
                              <th width="25">Nama</th>
                              <th width="60">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="loading">
                              <td colspan="4">Loading…</td>
                            </tr>
                            <tr v-else-if="error">
                              <td colspan="4">Gagal memuat data</td>
                            </tr>
                            <tr v-if="!loading && !error" v-for="(s, i) in paginatedSiswa" :key="s.id">
                              <th scope="row">{{ pageStart + i + 1 }}</th>
                              <td>{{ s.nis }}
                                <span
                                  class="badge ml-2"
                                  :class="isInClass(s.id) ? 'badge-primary' : 'badge-secondary'"
                                >
                                  {{ isInClass(s.id) ? 'Di kelas' : 'Belum' }}
                                </span>
                              </td>
                              <td>{{ s.nama }}
                              </td>
                              <td class="p-1">
                                <div class="radio-inline-row-kegiatan">
                                  <!-- radios -->
                                  <div
                                    v-for="opt in listoutputkegiatan"
                                    :key="opt.id"
                                    class="custom-control custom-radio custom-control-inline mr-2"
                                  >
                                    <input
                                      type="radio"
                                      class="custom-control-input"
                                      :id="`out_${s.id}_${opt.id}`"
                                      :name="'out_'+s.id"
                                      v-model="selectedOutput[s.id]"
                                      :value="String(opt.id)"
                                      :disabled="!canPickOutput"
                                      
                                    />
                                    <label class="custom-control-label" :for="`out_${s.id}_${opt.id}`">
                                      {{ opt.text }}
                                    </label>
                                  </div>

                                  <!-- textfield rencana selanjutnya -->
                                  <input
                                    type="text"
                                    class="form-control form-control-sm ml-2"
                                    :placeholder="'Keterangan'"
                                    v-model.trim="nextPlan[s.id]"
                                    :disabled="!canPickOutput"
                                    style="min-width:220px; max-width:360px;"
                                    
                                  />
                                  <a href="#" class="btn btn-sm btn-danger" @click="batal(s.id)" ><span class="fa fa-times"></span> Clear</a>
                                </div>
                              </td>


                            </tr>

                            <tr v-if="!loading && !error && paginatedSiswa.length === 0">
                              <td colspan="4">Tidak ada data</td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Footer: info & pager -->
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="small text-muted">
                            Menampilkan {{ Math.min(pageStart + 1, filteredCount) }}–{{ Math.min(pageStart + pageSize, filteredCount) }}
                            dari {{ filteredCount }} data
                          </div>

                          <ul class="pagination pagination-sm mb-0" role="navigation" aria-label="Pagination">
                            <li class="page-item" :class="{ disabled: page === 1 }">
                              <button type="button" class="page-link" @click="goto(1)" :disabled="page === 1">«</button>
                            </li>
                            <li class="page-item" :class="{ disabled: page === 1 }">
                              <button type="button" class="page-link" @click="prev" :disabled="page === 1">‹</button>
                            </li>

                            <li class="page-item disabled">
                              <span class="page-link">Page {{ page }} / {{ totalPages }}</span>
                            </li>

                            <li class="page-item" :class="{ disabled: page === totalPages }">
                              <button type="button" class="page-link" @click="next" :disabled="page === totalPages">›</button>
                            </li>
                            <li class="page-item" :class="{ disabled: page === totalPages }">
                              <button type="button" class="page-link" @click="goto(totalPages)" :disabled="page === totalPages">»</button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="modal-body" v-show="(!editmode && !pesertamode && !aktivitasmode && makminmode)">
                      <div class="form-group row">
                          <label class="col-md-2">Nama Kelas</label>
                          <div class="col-md-10">
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }" readonly="readonly">
                            <has-error :form="form" field="nama"></has-error>
                          </div>
                      </div>
                      <div class="col-12 col-sm-12">
                          <small v-if="!canPickMakmin" class="text-danger">Pilih Tanggal dulu</small>
                      </div>
                      <div class="col-12 col-sm-12">
                        <div class="form-group row">
                            <!-- <label class="col-md-2">Tgl Kegiatan</label> -->
                            <div class="offset-md-8 col-md-4">
                              <date-picker v-model="form.tgl_kegiatan" valueType="format" input-class="form-control" style="width: 100%;" placeholder="Date..." @change="changedate($event)"></date-picker>
                            </div>
                        </div>
                      </div>
                      <!-- GLOBAL MAKMIN (satu untuk semua siswa) -->
                      <div class="card card-body p-2 mb-3">
                        <div class="row">
                          <!-- Breakfast -->
                          <div class="col-md-3">
                            <label class="col-md-6">Breakfast Jam</label>
                            <div class="col-md-12">
                            <date-picker
                              v-model="form.breakfast_jam"
                              type="time"
                              format="HH:mm"
                              value-type="format"
                              input-class="form-control"
                              style="width:100%"     
                              :editable="true"
                            />
                            </div>
                            <has-error :form="form" field="breakfast_jam"></has-error>
                          </div>
                          <div class="col-md-3">
                            <label class="col-md-6">Breakfast Menu</label>
                            <div class="col-md-12">
                            <input
                              v-model="form.breakfast_menu"
                              type="text"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('breakfast_menu') }"
                              placeholder="Contoh: Roti & Susu"
                            />
                            </div>
                            <has-error :form="form" field="breakfast_menu"></has-error>
                          </div>

                          <!-- Lunch -->
                          <div class="col-md-3">
                            <label class="col-md-6">Lunch Jam</label>
                            <div class="col-md-12">
                            <date-picker
                              v-model="form.lunch_jam"
                              type="time"
                              format="HH:mm"
                              value-type="format"
                              input-class="form-control"
                              style="width:100%"
                              :editable="true"
                            />
                            </div>
                            <has-error :form="form" field="lunch_jam"></has-error>
                          </div>
                          <div class="col-md-3">
                            <label class="col-md-6">Lunch Menu</label>
                            <div class="col-md-12">
                            <input
                              v-model="form.lunch_menu"
                              type="text"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('lunch_menu') }"
                              placeholder="Contoh: Nasi Goreng"
                            />
                            </div>
                            <has-error :form="form" field="lunch_menu"></has-error>
                          </div>
                        </div>

                        <div class="row">
                          <!-- Snack -->
                          <div class="col-md-3">
                            <label class="col-md-6">Snack Jam</label>
                            <div class="col-md-12">
                            <date-picker
                              v-model="form.snack_jam"
                              type="time"
                              format="HH:mm"
                              value-type="format"
                              input-class="form-control"
                              style="width:100%"
                              :editable="true"
                            />
                            </div>
                            <has-error :form="form" field="snack_jam"></has-error>
                          </div>
                          <div class="col-md-3">
                            <label class="col-md-6">Snack Menu</label>
                            <div class="col-md-12">
                            <input
                              v-model="form.snack_menu"
                              type="text"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('snack_menu') }"
                              placeholder="Contoh: Donat & Susu"
                            />
                            </div>
                            <has-error :form="form" field="snack_menu"></has-error>
                          </div>

                          <!-- Dinner -->
                          <div class="col-md-3">
                            <label class="col-md-6">Dinner Jam</label>
                            <div class="col-md-12">
                            <date-picker
                              v-model="form.dinner_jam"
                              type="time"
                              format="HH:mm"
                              value-type="format"
                              input-class="form-control"
                              style="width:100%"
                              :editable="true"
                            />
                            </div>
                            <has-error :form="form" field="dinner_jam"></has-error>
                          </div>
                          <div class="col-md-3">
                            <label class="col-md-6">Dinner Menu</label>
                            <div class="col-md-12">
                            <input
                              v-model="form.dinner_menu"
                              type="text"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('dinner_menu') }"
                              placeholder="Contoh: Ayam Goreng"
                            />
                            <has-error :form="form" field="dinner_menu"></has-error>
                          </div>
                          </div>
                        </div>
                      </div>


                      <hr/>
                      <div class="form-group row">
                        <!-- Toolbar: Search & Rows per page (Bootstrap 4) -->
                        <div class="d-flex align-items-center justify-content-between mb-2 w-100">
                          <!-- Input Group B4: pakai .input-group-prepend -->


                          <!-- B4 tidak punya .gap-2, dan .form-select → pakai .custom-select -->
                          <div class="d-flex align-items-center">
                            <!-- Status -->
                            <span class="text-muted small mr-2">Status</span>
                            <select
                              class="custom-select custom-select-sm mr-3"
                              v-model="statusFilter"
                              style="width:auto;"
                            >
                              <!-- <option value="all">Semua</option> -->
                              <option value="in">Di kelas</option>
                              <!-- <option value="out">Belum</option> -->
                            </select>

                            <!-- Rows -->
                            <span class="text-muted small mr-2">Rows</span>
                            <select
                              class="custom-select custom-select-sm"
                              v-model.number="pageSize"
                              style="width:auto;"
                            >
                              <option :value="5">5</option>
                              <option :value="10">10</option>
                              <option :value="20">20</option>
                              <option :value="50">50</option>
                            </select>
                          </div>
                          <div class="input-group" style="max-width:320px;">
                            <div class="input-group-prepend">
                              <span class="input-group-text"><span class="fa fa-search"></span></span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="q"
                              placeholder="Cari NIS / Nama / ID…"
                              autocomplete="off"
                              @keydown.enter.prevent
                            />
                          </div>
                        </div>

                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th width="5">#</th>
                              <th width="10">NIS</th>
                              <th width="25">Nama</th>
                              <th width="60">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="loading">
                              <td colspan="4">Loading…</td>
                            </tr>
                            <tr v-else-if="error">
                              <td colspan="4">Gagal memuat data</td>
                            </tr>
                            <tr v-if="!loading && !error" v-for="(s, i) in paginatedSiswa" :key="s.id">
                              <th scope="row">{{ pageStart + i + 1 }}</th>
                              <td>{{ s.nis }}
                                <span
                                  class="badge ml-2"
                                  :class="isInClass(s.id) ? 'badge-primary' : 'badge-secondary'"
                                >
                                  {{ isInClass(s.id) ? 'Di kelas' : 'Belum' }}
                                </span>
                              </td>
                              <td>{{ s.nama }}
                              </td>
                              <td class="p-1">
                                <div v-if="makminKet[s.id]" class="radio-inline-row">
                                  <!-- Breakfast -->
                                  <div class="mr-3 d-flex align-items-center">
                                    
                                    <div v-for="opt in listoutputmakmin" :key="`bf_${s.id}_${opt.id}`" class="custom-control custom-radio custom-control-inline mr-2">
                                      <input
                                        type="radio"
                                        class="custom-control-input"
                                        :id="`bf_${s.id}_${opt.id}`"
                                        :name="`bf_${s.id}`"
                                        v-model="makminKet[s.id].breakfast_ket"
                                        :value="String(opt.id)"
                                        :disabled="!canPickMakmin"
                                      />
                                      <label class="custom-control-label" :for="`bf_${s.id}_${opt.id}`">{{ opt.text }}</label>
                                    </div>
                                    <small class="text-muted mr-2">Breakfast</small>
                                  </div>
                                  <br/>
                                  <!-- Lunch -->
                                  <div class="mr-3 d-flex align-items-center">
                                    
                                    <div v-for="opt in listoutputmakmin" :key="`ln_${s.id}_${opt.id}`" class="custom-control custom-radio custom-control-inline mr-2">
                                      <input
                                        type="radio"
                                        class="custom-control-input"
                                        :id="`ln_${s.id}_${opt.id}`"
                                        :name="`ln_${s.id}`"
                                        v-model="makminKet[s.id].lunch_ket"
                                        :value="String(opt.id)"
                                        :disabled="!canPickMakmin"
                                      />
                                      <label class="custom-control-label" :for="`ln_${s.id}_${opt.id}`">{{ opt.text }}</label>
                                    </div>
                                    <small class="text-muted mr-2">Lunch</small>
                                  </div>
                                  <br/>
                                  <!-- Snack -->
                                  <div class="mr-3 d-flex align-items-center">
                                    
                                    <div v-for="opt in listoutputmakmin" :key="`sn_${s.id}_${opt.id}`" class="custom-control custom-radio custom-control-inline mr-2">
                                      <input
                                        type="radio"
                                        class="custom-control-input"
                                        :id="`sn_${s.id}_${opt.id}`"
                                        :name="`sn_${s.id}`"
                                        v-model="makminKet[s.id].snack_ket"
                                        :value="String(opt.id)"
                                        :disabled="!canPickMakmin"
                                      />
                                      <label class="custom-control-label" :for="`sn_${s.id}_${opt.id}`">{{ opt.text }}</label>
                                    </div>
                                    <small class="text-muted mr-2">Snack</small>
                                  </div>
                                  <br/>
                                  <!-- Dinner -->
                                  <div class="mr-1 d-flex align-items-center">
                                    
                                    <div v-for="opt in listoutputmakmin" :key="`dn_${s.id}_${opt.id}`" class="custom-control custom-radio custom-control-inline mr-2">
                                      <input
                                        type="radio"
                                        class="custom-control-input"
                                        :id="`dn_${s.id}_${opt.id}`"
                                        :name="`dn_${s.id}`"
                                        v-model="makminKet[s.id].dinner_ket"
                                        :value="String(opt.id)"
                                        :disabled="!canPickMakmin"
                                      />
                                      <label class="custom-control-label" :for="`dn_${s.id}_${opt.id}`">{{ opt.text }}</label>
                                    </div>
                                    <small class="text-muted mr-2">Dinner</small>
                                  </div>
                                  <a href="#" class="btn btn-sm btn-danger" @click="batal(s.id)" ><span class="fa fa-times"></span> Clear</a>
                                </div>

                                <div v-else class="text-muted small">Memuat…</div>
                              </td>




                            </tr>

                            <tr v-if="!loading && !error && paginatedSiswa.length === 0">
                              <td colspan="4">Tidak ada data</td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Footer: info & pager -->
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="small text-muted">
                            Menampilkan {{ Math.min(pageStart + 1, filteredCount) }}–{{ Math.min(pageStart + pageSize, filteredCount) }}
                            dari {{ filteredCount }} data
                          </div>

                          <ul class="pagination pagination-sm mb-0" role="navigation" aria-label="Pagination">
                            <li class="page-item" :class="{ disabled: page === 1 }">
                              <button type="button" class="page-link" @click="goto(1)" :disabled="page === 1">«</button>
                            </li>
                            <li class="page-item" :class="{ disabled: page === 1 }">
                              <button type="button" class="page-link" @click="prev" :disabled="page === 1">‹</button>
                            </li>

                            <li class="page-item disabled">
                              <span class="page-link">Page {{ page }} / {{ totalPages }}</span>
                            </li>

                            <li class="page-item" :class="{ disabled: page === totalPages }">
                              <button type="button" class="page-link" @click="next" :disabled="page === totalPages">›</button>
                            </li>
                            <li class="page-item" :class="{ disabled: page === totalPages }">
                              <button type="button" class="page-link" @click="goto(totalPages)" :disabled="page === totalPages">»</button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="(editmode && !pesertamode && !aktivitasmode && !makminmode)" type="submit" class="btn btn-success">Update</button>
                        <button v-show="(!editmode && !pesertamode && !aktivitasmode && !makminmode)" type="submit" class="btn btn-primary">Create</button>
                        <!-- <button v-show="(!editmode && pesertamode && !aktivitasmode)" type="submit" class="btn btn-primary">Save</button> -->
                        <button v-show="(!editmode && !pesertamode && aktivitasmode && !makminmode)" type="submit" class="btn btn-primary" :disabled="!canPickOutput">Save</button>
                        <button v-show="(!editmode && !pesertamode && !aktivitasmode && makminmode)" type="submit" class="btn btn-primary" :disabled="!canPickMakmin">Save</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>

  </section>
</template>

<script>
    import DataTable from '../../../components/DataTable.vue';
    import DatePicker from 'vue2-datepicker';
    import Delete from '../../../components/DeleteButton.vue';
    import Edit from '../../../components/EditButton.vue';
    import Peserta from '../../../components/PesertaButton.vue';
    import KelasAktivitas from '../../../components/KelasAktivitasButton.vue';
    import KelasMakMin from '../../../components/KelasMakMinButton.vue';
    import { EventBus } from '../../../eventBus.js';
    import Select2 from '../../../components/Select2.vue';
    import Select2Ajax from '../../../components/Select2Ajax.vue';
    import 'vue2-datepicker/index.css';

    export default {
      components: {
          DataTable,
          DatePicker,
          Select2,
          Select2Ajax,
        },
        props:{
          title:''
        },
        data () {
            return {
                isKelasValid: false,
                editmode: false,
                pesertamode: false,
                aktivitasmode: false,
                makminmode: false,
                loading: false,
                error: null,        // <-- tambahkan ini
                user:'',
                loginType:'',
                makminKet: {},
                makminRecBySiswa: {},
                formdata : {},
                form: new Form({
                    id : '',
                    nama : '',
                    id_kelas: '',
                    keterangan: '',
                    tgl_awal: '',
                    tgl_akhir: '',
                    status_kelas: 1,
                    id_kegiatan:'',
                    tgl_kegiatan:'',
                    breakfast_jam: '',
                    breakfast_menu: '',
                    lunch_jam: '',
                    lunch_menu: '',
                    snack_jam: '',
                    snack_menu: '',
                    dinner_jam: '',
                    dinner_menu: '',
                }),             
                ajaxurl : 'api/list/indikator-kegiatan',
                tag:  '',
                autocompleteItems: [],
                contents: 0,
                liststatus:[
                          {text: 'Aktif', id: 1},
                          {text: 'Tidak Aktif', id: 0}
                        ],
                listkelas:[],
                listsiswaaktif:[],
                listpesertakelas:[],
                listkegiatankelas:[],
                listaktivitaskelas:[],
                listkegiatan: [],
                listoutputkegiatan: [],
                listoutputmakmin: [],
                selectedOutput: {},      // { [idSiswa]: 'id_output_kegiatan' }
                nextPlan: {},
                recordsBySiswa: {},      // opsional: simpan record mentah per siswa
                deletingId: null,
                columns: [
                    {title: 'No.',data: 'no', name: 'no',width:"2%"},
                    {title: 'Nama Program',data: 'nama_kelas', name:'b.nama_kelas'},
                    {title: 'Nama Kelas',data: 'name', name:'a.nama'},
                    {title: 'Keterangan',data: 'keterangan', name:'a.keterangan'},
                    // {title: 'Tgl. Awal',data: 'tgl_awal', name:'a.tgl_awal'},
                    // {title: 'Tgl. Akhir',data: 'tgl_akhir', name:'a.tgl_akhir'},
                    {title: 'Status',data: 'status_kelas', name:'a.status_kelas'},
                    {
                        data: 'action',
                        orderable: false,
                        searchable: false,
                        createdCell(cell, cellData, rowData) {
                            let DeleteButton = Vue.extend(Delete);
                            let instance = new DeleteButton({
                                propsData: rowData
                            });
                            instance.$mount();

                            let EditButton = Vue.extend(Edit);
                            let instanceEdit = new EditButton({
                                propsData: rowData
                            });
                            instanceEdit.$mount();

                            let PesertaButton = Vue.extend(Peserta);
                            let instancePeserta = new PesertaButton({
                                propsData: rowData
                            });
                            instancePeserta.$mount();

                            let KelasAktivitasButton = Vue.extend(KelasAktivitas);
                            let instanceKelasAktivitas = new KelasAktivitasButton({
                                propsData: rowData
                            });
                            instanceKelasAktivitas.$mount();

                            let KelasMakMinButton = Vue.extend(KelasMakMin);
                            let instanceKelasMakMin = new KelasMakMinButton({
                                propsData: rowData
                            });
                            instanceKelasMakMin.$mount();
                            
                            $(cell).empty().append(instanceEdit.$el).append(" ").append(instancePeserta.$el).append(" ").append(instanceKelasAktivitas.$el).append(" ").append(instanceKelasMakMin.$el).append(" ").append(instance.$el);
                        }
                    },

                ],
                ajax: {
                  url : '/api/pesertakelas',
                  beforeSend: function (xhr){ 
                
                  },
                  error: data => {
                    // console.log(data);
                    if(data.status == 401){
                        this.$emit('logout')
                    }
                  },
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + localStorage.getItem('token')
                  },
                },
                exportcolumn:[
                          {label: '#',field: 'no', },
                          {label: 'Nama',field: 'nama_kelas', },
                          {label: 'Tgl. Awal',field: 'tgl_awal', },
                          {label: 'Tgl. Akhir',field: 'tgl_akhir', },
                          {label: 'Status',field: 'status', },
                        ],
                exportdata:[],
                // UI state
                q: '',                // kata kunci pencarian
                page: 1,              // halaman aktif
                pageSize: 10,          // jumlah baris per halaman (5/10/20/50)
                statusFilter: 'all',  // 'all' | 'in' | 'out'
            }
        },
        methods: {
          loadKelas(){
            return axios.get("api/list/kelas")
              .then(({ data }) => { this.listkelas = data.data; });
          },
          loadNilai(){
            return axios.get("api/list/nilai-output-kegiatan")
              .then(({ data }) => { this.listoutputkegiatan = data.data; });
          },
          loadNilaiMakmin(){
            return axios.get("api/list/nilai-output-makan")
              .then(({ data }) => { this.listoutputmakmin = data.data; });
          },
          loadKegiatan(){
            return axios.get("api/list/indikator-kegiatan")
              .then(({ data }) => { this.listkegiatan = data.data; });
          },
          loadSiswaAktif(){
            return axios.get("api/list/siswaaktif")
              .then(({ data }) => { this.listsiswaaktif = data.data; });
          },
          loadPesertaKelas(id){
            return axios.get("api/list/pesertakelas/"+id)
              .then(({ data }) => { this.listpesertakelas = data?.data ?? []; });
          },
          loadKegiatanKelas(tgl) {
            return axios
              .get(`api/list/kegiatan-kelas/${tgl}/${this.form.id_kelas}`)
              .then(({ data }) => {
                this.listkegiatankelas = data?.data ?? [];
                // reset seleksi jika id sebelumnya tidak ada di list baru
                if (!this.listkegiatankelas.some(x => x.id === this.selectedKegiatanId)) {
                  this.selectedKegiatanId = null;
                  this.form.id_kegiatan = null;
                }
              });
          },
          loadDataExport(){
            return axios.get("/api/export/pesertakelas")
              .then(({ data }) => { this.exportdata = data.data; });
          },
          refreshPageData() {
            if (this.aktivitasmode) this.fetchOutputsForPage();
            if (this.makminmode)    this.fetchMakminForPage();
          },
          setGlobalFromRecord(rec) {
            if (!rec) return;
            if (!this.form.breakfast_jam  && rec.breakfast_jam)  this.form.breakfast_jam  = rec.breakfast_jam;
            if (!this.form.breakfast_menu && rec.breakfast_menu) this.form.breakfast_menu = rec.breakfast_menu;
            if (!this.form.lunch_jam      && rec.lunch_jam)      this.form.lunch_jam      = rec.lunch_jam;
            if (!this.form.lunch_menu     && rec.lunch_menu)     this.form.lunch_menu     = rec.lunch_menu;
            if (!this.form.snack_jam      && rec.snack_jam)      this.form.snack_jam      = rec.snack_jam;
            if (!this.form.snack_menu     && rec.snack_menu)     this.form.snack_menu     = rec.snack_menu;
            if (!this.form.dinner_jam     && rec.dinner_jam)     this.form.dinner_jam     = rec.dinner_jam;
            if (!this.form.dinner_menu    && rec.dinner_menu)    this.form.dinner_menu    = rec.dinner_menu;
          },
          editModal(id){
              this.$Progress.start();  
              $('#pageloader').css('display','block');            
              this.editmode = true;
              this.pesertamode = false;
              this.aktivitasmode = false;
              this.makminmode = false;
              axios.get("/api/pesertakelas/"+id).then(({ data }) => {
                  this.formdata = data.data
                  this.editmode = true
                  this.form.reset();
                  this.form.fill(this.formdata);
                  setTimeout(() => {         
                    this.kelasexist();
                    $('#pageloader').css('display','none');               
                  }, 300);
                  $('#addNew').modal('show');
                  this.$Progress.finish();
              });

          },
          async pesertaModal(id){
              this.$Progress.start();  
              $('#pageloader').css('display','block');            
              this.editmode = false;
              this.pesertamode = true;
              this.aktivitasmode = false;
              this.makminmode = false;
              await this.loadPesertaKelas(id);
              axios.get("/api/pesertakelas/"+id).then(({ data }) => {
                  this.formdata = data.data
                  this.pesertamode = true
                  this.form.reset();
                  this.form.fill(this.formdata);
                  setTimeout(() => {         
                    $('#pageloader').css('display','none');               
                  }, 300);
                  $('#addNew').modal('show');
                  this.$Progress.finish();
              });

          },
          async aktivitasModal(id){
              this.$Progress.start();  
              $('#pageloader').css('display','block');        
              this.selectedOutput = {};     
              this.editmode = false;
              this.pesertamode = false;
              this.aktivitasmode = true;
              this.makminmode = false;
              await this.loadPesertaKelas(id);
              axios.get("/api/pesertakelas/"+id).then(({ data }) => {
                  this.formdata = data.data
                  this.aktivitasmode = true
                  this.form.reset();
                  this.form.fill(this.formdata);
                  setTimeout(() => {         
                    $('#pageloader').css('display','none');               
                  }, 300);
                  $('#addNew').modal('show');
                  this.$Progress.finish();
              });

          },
          async makminModal(id){
              this.$Progress.start();  
              $('#pageloader').css('display','block');        
              this.selectedOutput = {};     
              this.editmode = false;
              this.pesertamode = false;
              this.aktivitasmode = false;
              this.makminmode = true;
              await this.loadPesertaKelas(id);
              axios.get("/api/pesertakelas/"+id).then(({ data }) => {
                  this.formdata = data.data
                  this.makminmode = true
                  this.form.reset();
                  this.form.fill(this.formdata);
                  setTimeout(() => {         
                    $('#pageloader').css('display','none');               
                  }, 300);
                  $('#addNew').modal('show');
                  this.$Progress.finish();
              });

          },
          newModal(){
              this.editmode = false;
              this.pesertamode = false;
              this.aktivitasmode = false;
              this.makminmode = false;
              this.isKelasValid = true;
              $('#pageloader').css('display','block');
              this.form.reset();
              $('#addNew').modal('show');
              setTimeout(() => {                      
                $('#modalform').modal('show');
                $('#pageloader').css('display','none');    
            }, 300);
          },
          createData(){
              this.$Progress.start();              
              $('#pageloader').css('display','block');
              this.form.post('/api/pesertakelas')
              .then((data)=>{
                if(data.data.success){
                  setTimeout(() => {                        
                        $('#addNew').modal('hide');
                        Toast.fire({
                              icon: 'success',
                              title: data.data.message
                          });
                        EventBus.$emit('dataTableReload', null) 
                        $('#pageloader').css('display','none');    
                        this.$Progress.finish();
                  }, 300);

                } else {
                  setTimeout(() => {                        
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                        $('#pageloader').css('display','none');    
                        this.$Progress.failed();
                  }, 300);

                }
              })
              .catch((data)=>{
                  setTimeout(() => {                      
                      Toast.fire({
                          icon: 'error',
                          title: 'Some error occured! Please try again'
                      });
                      if(data.response.status == 401){
                          this.$emit('logout')
                      }
                      $('#pageloader').css('display','none');    
                  }, 300);
              })
          },
          updateData(){
              this.$Progress.start();             
              $('#pageloader').css('display','block'); 
              this.form.put('/api/pesertakelas/'+this.form.id)
              .then((response) => {
                  // success
                  setTimeout(() => {
                  $('#addNew').modal('hide');                      
                      Toast.fire({
                        icon: 'success',
                        title: response.data.message
                      });
                      EventBus.$emit('dataTableReload', null) 
                      $('#pageloader').css('display','none');   
                      this.$Progress.finish();
                  }, 300);
                      //  Fire.$emit('AfterCreate');
              })
              .catch((data) => {
                  setTimeout(() => {                      
                      Toast.fire({
                          icon: 'error',
                          title: 'Some error occured! Please try again'
                      });
                      if(data.response.status == 401){
                          this.$emit('logout')
                      }
                      $('#pageloader').css('display','none');   
                      this.$Progress.fail();
                  }, 300);
              });

          },
          pesertaData(data){
              this.$Progress.start();             
              $('#pageloader').css('display','block'); 
              this.form.post('/api/updatepesertakelas/'+this.form.id+"/peserta/"+data.id)
              .then(async (response) => {
                  // success
                  await this.loadPesertaKelas(this.form.id);
                  setTimeout(() => {
                  // $('#addNew').modal('hide');                      
                      Toast.fire({
                        icon: 'success',
                        title: response.data.message
                      });
                      EventBus.$emit('dataTableReload', null) 
                      $('#pageloader').css('display','none');   
                      this.$Progress.finish();
                  }, 300);
                      //  Fire.$emit('AfterCreate');
              })
              .catch((data) => {
                  setTimeout(() => {                      
                      Toast.fire({
                          icon: 'error',
                          title: 'Some error occured! Please try again'
                      });
                      if(data.response.status == 401){
                          this.$emit('logout')
                      }
                      $('#pageloader').css('display','none');   
                      this.$Progress.fail();
                  }, 300);
              });

          },
          async aktivitasData(){
              if (!this.canPickOutput) {
                Toast.fire({ icon: 'warning', title: 'Pilih Tanggal & Kegiatan dulu' });
                return;
              }

              // Kumpulkan data untuk siswa di halaman aktif
              const items = this.paginatedSiswa.map(s => ({
                id_siswa: String(s.id),
                id_kegiatan: String(this.form.id_kegiatan),
                id_kelas: String(this.form.id_kelas),
                tgl: this.form.tgl_kegiatan,                          // pastikan ada di DB kalau kamu pakai
                id_output_kegiatan: this.selectedOutput[s.id] ?? null,
                rencana_selanjutnya: this.nextPlan[s.id] ?? '',
              }));

              // (opsional) validasi ringan: pastikan ada minimal satu perubahan
              const adaIsi = items.some(it => it.id_output_kegiatan != null || it.rencana_selanjutnya);
              if (!adaIsi) {
                Toast.fire({ icon: 'info', title: 'Tidak ada perubahan untuk disimpan' });
                return;
              }

              this.$Progress.start();
              $('#pageloader').css('display', 'block');
              try {
                // Kirim ke endpoint bulk (buat di backend — contoh di bawah)
                await axios.post('/api/bulk-upsert/kegiatan-siswa', { items });
                
                Toast.fire({ icon: 'success', title: 'Kelas Aktivitas tersimpan' });
                // Refresh status halaman ini dari server biar sinkron
                await this.fetchOutputsForPage();
                this.loadKegiatanKelas(this.form.tgl_kegiatan);
                this.$Progress.finish();
              } catch (e) {
                console.error(e);
                Toast.fire({ icon: 'error', title: 'Gagal menyimpan aktivitas' });
                this.$Progress.fail();
              } finally {
                $('#pageloader').css('display', 'none');
              }

          },
          async makminData(){
              if (!this.canPickMakmin) {
                Toast.fire({ icon: 'warning', title: 'Pilih Tanggal dulu' });
                return;
              }

              // siapkan payload per siswa (halaman aktif saja; ganti ke filteredSiswa kalau mau semua)
              const items = this.paginatedSiswa.map(s => {
                const ket = this.makminKet[s.id] || {};
                return {
                  id_siswa: String(s.id),
                  tgl: this.form.tgl_kegiatan,           // dipakai di kolom tgl_daily_makmin
                  // GLOBAL (sama utk semua siswa)
                  breakfast_jam:  this.form.breakfast_jam  || null,
                  breakfast_menu: this.form.breakfast_menu || '',
                  lunch_jam:      this.form.lunch_jam      || null,
                  lunch_menu:     this.form.lunch_menu     || '',
                  snack_jam:      this.form.snack_jam      || null,
                  snack_menu:     this.form.snack_menu     || '',
                  dinner_jam:     this.form.dinner_jam     || null,
                  dinner_menu:    this.form.dinner_menu    || '',
                  // PER SISWA (radio)
                  breakfast_ket:  ket.breakfast_ket ?? null,
                  lunch_ket:      ket.lunch_ket     ?? null,
                  snack_ket:      ket.snack_ket     ?? null,
                  dinner_ket:     ket.dinner_ket    ?? null,
                };
              });

              const adaIsi = items.some(it =>
                it.breakfast_ket != null || it.lunch_ket != null || it.snack_ket != null || it.dinner_ket != null ||
                it.breakfast_menu || it.lunch_menu || it.snack_menu || it.dinner_menu ||
                it.breakfast_jam || it.lunch_jam || it.snack_jam || it.dinner_jam
              );
              if (!adaIsi) {
                Toast.fire({ icon: 'info', title: 'Tidak ada perubahan untuk disimpan' });
                return;
              }

              this.$Progress.start();
              $('#pageloader').css('display', 'block');
              try {
                await axios.post('/api/bulk-upsert/makmin', { items });
                Toast.fire({ icon: 'success', title: 'Makan dan Minum tersimpan' });
                await this.fetchMakminForPage();  // segarkan nilai dari server
                this.$Progress.finish();
              } catch (e) {
                console.error(e);
                Toast.fire({ icon: 'error', title: 'Gagal menyimpan makmin' });
                this.$Progress.fail();
              } finally {
                $('#pageloader').css('display', 'none');
              }

          },
          deleteData(id,name){
              Swal.fire({
                  title: 'Are you sure?',
                  text: "You won't be able to revert this "+name+"!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Yes, delete it!'
                  }).then((result) => {
                      // Send request to the server
                      this.$Progress.start();  
                      $('#pageloader').css('display','block');                     
                      if (result.value) {
                            this.form.delete('/api/pesertakelas/'+id).then(()=>{
                                setTimeout(() => {                                    
                                    Swal.fire(
                                    'Deleted!',
                                    'Your file has been deleted.',
                                    'success'
                                    );
                                    EventBus.$emit('dataTableReload', null) 
                                    $('#pageloader').css('display','none');   
                                    this.$Progress.finish();
                                }, 300);
                                // Fire.$emit('AfterCreate');
                            }).catch((data)=> {
                                setTimeout(() => {                                    
                                    Swal.fire("Failed!", data.message, "warning");
                                    $('#pageloader').css('display','none');   
                                    if(data.response.status == 401){
                                        this.$emit('logout')
                                    }
                                    this.$Progress.fail();
                                }, 300);
                            });
                      }else{
                          setTimeout(() => {                                
                                $('#pageloader').css('display','none');   
                                this.$Progress.fail();
                            }, 300);
                      }
                  })
          },
          myChangeEvent(event){

          },
          mySelectEvent(event){

          },
          kelasexist() {
            const v = this.form.id_kelas;
            const l = this.listkelas;
              // jika kosong/null, langsung dianggap tidak ada
            if (v == null || v === '') return false;

            // ubah ke string agar aman dari perbedaan tipe (number vs string)
            const idStr = String(v);

            // cek apakah ada item dengan id sama
            const found = l.some(item => String(item.id) === idStr);

            // return found; // true = ada, false = tidak ada
            this.isKelasValid = found;
          },
          batal(id){
            this.$set(this.selectedOutput, id, null); // atau ''
            this.$set(this.nextPlan, id, '');
            if (!this.makminKet[id]) {
              this.$set(this.makminKet, id, this.defaultMakmin());
            }

            // reset semua radio makmin pada row yg sama
            this.$set(this.makminKet[id], 'breakfast_ket', null);
            this.$set(this.makminKet[id], 'lunch_ket', null);
            this.$set(this.makminKet[id], 'snack_ket', null);
            this.$set(this.makminKet[id], 'dinner_ket', null);
          },
          fetchSiswa() {
            this.loading = true;
            this.error = null;
            axios.get("api/list/siswaaktif")
              .then(({ data }) => {
                this.listsiswaaktif = data?.data ?? [];
              })
              .catch(err => { this.error = err; })
              .finally(() => { this.loading = false; });
          },
          async fetchKegiatanForSiswa(siswaId) {
            if (!this.canPickOutput) {
              this.$set(this.selectedOutput, siswaId, null);
              this.$set(this.nextPlan, siswaId, '');     // ⬅️ kosongkan juga
              return;
            }
            const url = `api/list/kegiatan-siswa/${siswaId}/${this.form.id_kegiatan}/${this.form.tgl_kegiatan}`;
            try {
              const { data } = await axios.get(url);
              const rows = data?.data ?? [];
              const rec = rows[0] || null;

              this.$set(this.recordsBySiswa, siswaId, rec);
              this.$set(this.selectedOutput, siswaId, rec ? String(rec.id_output_kegiatan) : null);
              this.$set(this.nextPlan, siswaId, rec?.rencana_selanjutnya || '');  // ⬅️ set nilai awal
            } catch (e) {
              this.$set(this.recordsBySiswa, siswaId, null);
              this.$set(this.selectedOutput, siswaId, null);
              this.$set(this.nextPlan, siswaId, '');                               // ⬅️ kosongkan saat error
            }
          },
          async fetchOutputsForPage() {
                    if (!this.canPickOutput) {
                      this.paginatedSiswa.forEach(s => {
                        this.$set(this.selectedOutput, s.id, null);
                        this.$set(this.nextPlan, s.id, '');     // ⬅️
                      });
                      return;
                    }
                    await Promise.all(this.paginatedSiswa.map(s => this.fetchKegiatanForSiswa(s.id)));
          },
          async fetchMakminForSiswa(sid) {
            if (!this.canPickMakmin) {
              this.ensureMakminSlot(sid);
              return;
            }
            try {
              const url = `api/list/makmin-siswa/${sid}/${this.form.tgl_kegiatan}`;
              const { data } = await axios.get(url);
              const rec = (data && data.data && data.data[0]) || null;

              this.$set(this.makminRecBySiswa, sid, rec);

              this.ensureMakminSlot(sid, {
                breakfast_ket: rec?.breakfast_ket,
                lunch_ket:     rec?.lunch_ket,
                snack_ket:     rec?.snack_ket,
                dinner_ket:    rec?.dinner_ket,
              });

              this.setGlobalFromRecord(rec); // global jam/menu tetap boleh di-prefill
            } catch (e) {
              this.ensureMakminSlot(sid); // tetap ada slot, tapi semuanya null
            }
          },

          defaultMakminSlot() {
            return {
              breakfast_ket: null,
              lunch_ket: null,
              snack_ket: null,
              dinner_ket: null,
            };
          },

          ensureMakminSlot(sid, patch = {}) {
            if (!this.makminKet[sid]) {
              this.$set(this.makminKet, sid, this.defaultMakminSlot());
            }
            // apply nilai dari server jika ada; kalau null/undefined → tetap null (kosong)
            ['breakfast_ket','lunch_ket','snack_ket','dinner_ket'].forEach(k => {
              if (patch.hasOwnProperty(k)) {
                const v = patch[k];
                this.$set(this.makminKet[sid], k, v != null ? String(v) : null);
              } else if (!this.makminKet[sid].hasOwnProperty(k)) {
                this.$set(this.makminKet[sid], k, null);
              }
            });
          },

          async fetchMakminForPage() {
            this.paginatedSiswa.forEach(s => this.ensureMakminSlot(s.id));
            await Promise.all(this.paginatedSiswa.map(s => this.fetchMakminForSiswa(s.id)));
          },
          goto(p) {
            const n = Number(p);
            if (!Number.isFinite(n)) return;
            this.page = Math.min(Math.max(1, n), this.totalPages);
          },
          prev() { this.goto(this.page - 1); },
          next() { this.goto(this.page + 1); },
          pilih(s) {
            // aksi ketika klik tombol
            // console.log('pilih', s);
            this.pesertaData(s);
          },
          isInClass(siswaId) {
            return this.pesertaSet.has(String(siswaId));
          },
          changedate(val){
            this.form.tgl_kegiatan = val;   // (valueType="format" → string 'YYYY-MM-DD')
            this.page = 1;
            this.refreshPageData();     // reload status radio dari API
            this.loadKegiatanKelas(val);
          },
          selectKegiatan(item) {
            this.selectedKegiatanId = item.id;
            this.form.id_kegiatan = item.id;         // simpan ke form
          },
          async hapusKegiatan(item) {
            if (this.deletingId) return;
            // konfirmasi cepat (pakai SweetAlert2 jika ada)
            const go = window.Swal
              ? await Swal.fire({
                  title: 'Hapus kegiatan?',
                  text: item.text,
                  showCancelButton: true,
                  confirmButtonText: 'Hapus',
                  cancelButtonText: 'Batal',
                  confirmButtonColor: '#dc3545'
                }).then(r => r.isConfirmed)
              : window.confirm(`Hapus kegiatan ini?\n\n${item.text}`);

            if (!go) return;

            this.deletingId = item.id;
            this.$Progress?.start();
            try {
              // ganti endpoint sesuai API kamu
              // /hapuspesertakelas/{id}/{id_kegiatan}/{tgl}
              await this.form.post(`api/hapuspesertakelas/${this.form.id_kelas}/${item.id}/${this.form.tgl_kegiatan}`);
              // hapus dari list lokal
              this.listkegiatankelas = this.listkegiatankelas.filter(x => x.id !== item.id);
              if (this.selectedKegiatanId === item.id) {
                this.selectedKegiatanId = null;
                this.form.id_kegiatan = null;
              }
              window.Swal?.fire('Terhapus', 'Kegiatan berhasil dihapus.', 'success');
              EventBus?.$emit('dataTableReload', null);
              this.loadKegiatanKelas(this.form.tgl_kegiatan);
              this.$Progress?.finish();
            } catch (err) {
              const msg = err?.response?.data?.message || err?.message || 'Terjadi kesalahan.';
              window.Swal?.fire?.('Gagal', msg, 'warning');
              this.$Progress?.fail();
              if (err?.response?.status === 401) this.$emit('logout');
            } finally {
              this.deletingId = null;
            }
          }
        },
        beforeMount() {
          // if(this.$gate.isAdmin()){            
          // }else{
            // this.$router.push({ path: '/dashboard' });
          // }
        },
        mounted() {
            EventBus.$on('editValue', (id,name) => {
              // console.log('triggered '+ id + ' kelas  contents ' + name)
              this.editModal(id);
            })
            EventBus.$on('pesertaValue', (id,name) => {
              // console.log('triggered '+ id + ' kelas  contents ' + name)
              this.pesertaModal(id);
            })
            EventBus.$on('kelasAktivitasValue', (id,name) => {
              // console.log('triggered '+ id + ' kelas  contents ' + name)
              this.aktivitasModal(id);
            })
            EventBus.$on('kelasMakMinValue', (id,name) => {
              // console.log('triggered '+ id + ' kelas  contents ' + name)
              this.makminModal(id);
            })
            EventBus.$on('deleteValue', (id,name) => {
              // console.log('triggered '+ id + ' contents ' + name)
              this.deleteData(id,name);
            })
            this.fetchSiswa()
            this.loadNilai().then(() => this.fetchOutputsForPage())
        },
        async created() {
            this.$Progress.start();
            this.$emit('setAxios')            
            this.user = JSON.parse(localStorage.getItem('user'))
            this.loginType = this.user.roles[0].name
            await this.loadKelas();
            await this.loadSiswaAktif();
            await this.loadDataExport();
            await this.loadKegiatan();
            await this.loadNilai();
            await this.loadNilaiMakmin();
            this.$Progress.finish();
        },
        filters: {
            truncate: function (text, length, suffix) {
                return text.substring(0, length) + suffix;
            },
        },
        computed: {
          canPickOutput() {
            return !!(this.form.id_kegiatan && this.form.tgl_kegiatan);
          },
          canPickMakmin() {
            return !!this.form.tgl_kegiatan;
          },
          // Normalisasi: pisah NIS & Nama, singkirkan entri text null
          normalizedSiswa() {
            return (this.listsiswaaktif ?? [])
              .filter(r => r && r.text)
              .map(r => {
                const m = r.text.match(/^\[(.+?)\]\s*(.*)$/);
                return { id: r.id, nis: m ? m[1] : '', nama: m ? m[2] : r.text, text: r.text };
              });
          },
          // Filter by query (nis/nama/text/id)
          filteredSiswa() {
            const q = (this.q || '').toLowerCase().trim();
            const set = this.pesertaSet;

            return this.normalizedSiswa.filter(s => {
              const inClass = set.has(String(s.id));

              // filter status
              const statusOk =
                this.statusFilter === 'all' ? true :
                this.statusFilter === 'in'  ? inClass :
                !inClass; // 'out'

              if (!statusOk) return false;

              // filter search
              if (!q) return true;
              return (
                String(s.id).includes(q) ||
                (s.nis && s.nis.toLowerCase().includes(q)) ||
                (s.nama && s.nama.toLowerCase().includes(q)) ||
                (s.text && s.text.toLowerCase().includes(q))
              );
            });
          },
          defaultMakminVal() {
            const src = (this.listoutputmakmin && this.listoutputmakmin.length)
              ? this.listoutputmakmin
              : this.listoutputkegiatan;              // fallback kalau list makmin belum tersedia
            return (src && src.length) ? String(src[0].id) : '0';
          },
          filteredCount() {
            return this.filteredSiswa.length;
          },
          totalPages() {
            return Math.max(1, Math.ceil(this.filteredCount / this.pageSize));
          },
          pageStart() {
            return (this.page - 1) * this.pageSize;
          },
          paginatedSiswa() {
            // clamp halaman jika pencarian mengurangi total halaman
            const start = Math.min(this.pageStart, (this.totalPages - 1) * this.pageSize);
            return this.filteredSiswa.slice(start, start + this.pageSize);
          },
          pesertaSet() {
            const set = new Set();
            (this.listpesertakelas || []).forEach(r => {
              if (r && r.id_siswa != null) set.add(String(r.id_siswa));
            });
            return set;
          }
          
        },
        watch: {
          /* ====== Pagination / Search / Filter ====== */
          q() {
            this.page = 1;
            this.$nextTick(() => this.refreshPageData());
          },
          page() {
            this.refreshPageData();                 // pindah halaman ⇒ refetch data halaman
          },
          pageSize() {
            this.page = 1;
            this.$nextTick(() => this.refreshPageData());
          },
          statusFilter() {
            this.page = 1;
            this.$nextTick(() => this.refreshPageData());
          },
          /* ====== Mode switches ====== */
          aktivitasmode(val) {
            if (val) {
              this.statusFilter = 'in';             // hanya yang “Di kelas”
              this.$nextTick(() => this.fetchOutputsForPage());
            }
          },
          makminmode(val) {
            if (val) {
              this.statusFilter = 'in';             // hanya yang “Di kelas”
              this.$nextTick(() => this.fetchMakminForPage());
            }
          },
          pesertamode(val) {
            if (val) {
              this.statusFilter = 'all';            // tampilkan semua (peserta mode)
              // tidak perlu fetch khusus
            }
          },

          /* ====== Form controls ====== */
          // tanggal dipakai di kedua mode ⇒ refresh keduanya via helper
          'form.tgl_kegiatan'() {
            this.form.breakfast_jam  = '';
            this.form.breakfast_menu = '';
            this.form.lunch_jam      = '';
            this.form.lunch_menu     = '';
            this.form.snack_jam      = '';
            this.form.snack_menu     = '';
            this.form.dinner_jam     = '';
            this.form.dinner_menu    = '';
            this.refreshPageData();
          },
          // id_kegiatan hanya relevan untuk aktivitas
          'form.id_kegiatan'() {
            if (this.aktivitasmode) this.fetchOutputsForPage();
          },

          /* ====== Master opsi radio (opsional) ====== */
          // Kalau opsi radio baru masuk, refresh khusus aktivitas saja
          listoutputkegiatan() {
            if (this.aktivitasmode) this.fetchOutputsForPage();
          },
        },
        beforeDestroy(){
          EventBus.$off('editValue')
          EventBus.$off('pesertaValue')
          EventBus.$off('kelasAktivitasValue')
          EventBus.$off('deleteValue')
        }
    }
</script>
<style type="text/css">

  .modal-lg{
    width: 90% !important;
  }

  .modal-full {
    padding: 0 !important; 
  }
  .modal-full .modal-dialog-full {
    width: 100%;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-full .modal-content-full {
    /* height: 100%; */
    border: 0;
    border-radius: 0;
  }
  .modal-full .modal-body-full {
    overflow-y: auto;
  }

/* Keep radios in ONE line; allow horizontal scroll if sempit */
.radio-inline-row-kegiatan{
  display: flex;
  flex-wrap: nowrap;            /* penting: jangan bungkus ke baris berikut */
  align-items: center;
  overflow-x: auto;             /* kalau kepanjangan, bisa di-scroll horizontal */
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
  white-space: nowrap;          /* cegah teks badge pecah baris */
}
.radio-inline-row-kegiatan .form-check { white-space: nowrap; }


/* Tumpuk per-baris dengan grid 2 kolom: label | opsi */
.radio-grid{
  display: grid;
  grid-template-columns: 90px 1fr; /* sesuaikan lebar label */
  grid-auto-rows: auto;
  column-gap: .5rem;
  row-gap: .25rem;
  align-items: start;
}

/* kolom kiri untuk teks Breakfast/Lunch/... */
.radio-grid .label{
  justify-self: end;   /* rata kanan biar rapi */
  padding-top: .35rem; /* sejajarkan ke tengah radio */
  white-space: nowrap;
}

/* kolom kanan berisi radio yang bisa wrap */
.radio-grid .options{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

/* Hapus aturan lama yang memaksa satu baris */
.radio-inline-row{ all: unset; } /* atau jangan pakai class itu pada blok makmin */

 
</style>